var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"26","height":"26","fill":"#35404E","key":0}),React.createElement("path",{"d":"M19.4167 2H6.58333C4.05242 2 2 4.05242 2 6.58333V19.4167C2 21.9476 4.05242 24 6.58333 24H19.4167C21.9485 24 24 21.9476 24 19.4167V6.58333C24 4.05242 21.9485 2 19.4167 2ZM9.33333 19.4167H6.58333V9.33333H9.33333V19.4167ZM7.95833 8.171C7.07283 8.171 6.35417 7.44683 6.35417 6.554C6.35417 5.66117 7.07283 4.937 7.95833 4.937C8.84383 4.937 9.5625 5.66117 9.5625 6.554C9.5625 7.44683 8.84475 8.171 7.95833 8.171ZM20.3333 19.4167H17.5833V14.2797C17.5833 11.1923 13.9167 11.4261 13.9167 14.2797V19.4167H11.1667V9.33333H13.9167V10.9513C15.1963 8.58075 20.3333 8.40567 20.3333 13.2209V19.4167Z","fill":"white","key":1})]);
}

LinkedinInline.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
